/*Bootstrap v4.4.1*/
import 'bootstrap'

/*VueJs*/
import App from '@src/App.vue'

import Vue from 'vue'
window.Vue = Vue;

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import EventHub from 'vue-event-hub'
Vue.use(EventHub)

/*Router & Store*/
import router from '@src/router'
import store from '@store'

/*Axios configuration*/
require('@src/config/axios-settings.js')

/*Syncfusion*/
require('@src/assets/js/syncfusion-components.js')

/*Component*/
require('@components/components-settings.js')

/*Helpers*/
require('@src/assets/js/helpers.js')

/*I18n configuration*/
import messages from '@src/i18n/i18n-messages.js'

const i18n = new VueI18n({
	locale: 'es',
	messages,
})
window.I18n = i18n

Vue.config.productionTip = false

new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app')
